import type { TaskNode } from "./types";
import { newTask } from "./model";

const WORDS = {
  phases: ["Discovery", "Planning", "Design", "Development", "Integration", "Testing", "Rollout", "Launch", "Hardening", "Research", "Migration", "Onboarding"],
  areas: ["Frontend", "Backend", "API", "Database", "Auth", "Infra", "Mobile", "Analytics", "Payments", "Search", "Notifications", "Reporting"],
  acts: ["Design", "Build", "Refactor", "Test", "Document", "Review", "Deploy", "Spike", "Wire up", "Optimize", "Audit", "Configure"],
  nouns: ["layout", "schema", "endpoint", "pipeline", "dashboard", "form", "cache", "migration", "component", "service", "workflow", "module", "report", "queue", "webhook"],
};

function pick(arr: string[]): string {
  return arr[Math.floor(Math.random() * arr.length)];
}
function randInt(a: number, b: number): number {
  return a + Math.floor(Math.random() * (b - a + 1));
}

function buildNode(name: string, depth: number): TaskNode {
  const node = newTask(name);
  // probability of having children shrinks with depth; max depth 3
  const canBranch = depth < 3 && Math.random() < 0.85 - depth * 0.25;
  if (canBranch) {
    const kids = randInt(2, depth === 0 ? 4 : 3);
    for (let i = 0; i < kids; i++) {
      const childName = depth === 0 ? pick(WORDS.areas) : pick(WORDS.acts) + " " + pick(WORDS.nouns);
      node.children.push(buildNode(childName, depth + 1));
    }
    node.collapsed = false;
  } else {
    node.estimate = randInt(1, 8) * (Math.random() < 0.3 ? 0.5 : 1);
  }
  return node;
}

export function randomTree(): TaskNode[] {
  const phaseCount = randInt(3, 5);
  const phases: TaskNode[] = [];
  const usedPhases = new Set<string>();
  for (let i = 0; i < phaseCount; i++) {
    let label = pick(WORDS.phases);
    while (usedPhases.has(label)) label = pick(WORDS.phases) + " " + (i + 1);
    usedPhases.add(label);
    phases.push(buildNode(label, 0));
  }
  return phases;
}

// the default starter plan
export function seed(): TaskNode[] {
  const kickoff = newTask("Project kickoff");
  kickoff.children = [newTask("Define scope"), newTask("Stakeholder sign-off")];
  kickoff.children[0].estimate = 2;
  kickoff.children[1].estimate = 1;

  const build = newTask("Build");
  const fe = newTask("Frontend");
  fe.children = [newTask("Layout"), newTask("Table view"), newTask("Timeline view")];
  fe.children.forEach((c, i) => (c.estimate = [1, 3, 2][i]));
  const be = newTask("Backend");
  be.estimate = 4;
  build.children = [fe, be];

  const release = newTask("Release");
  release.estimate = 1;

  return [kickoff, build, release];
}
